import { Typography } from '@mui/material';
import { tour_13a_pile, tour_13pile } from 'constants/tour';

/* import { Check } from '@mui/icons-material';*/
export const stepsPile = [
  {
    selector: `.${tour_13a_pile.step_02}`,
    content: () => {
      return (
        <Typography>
          Clicca qui per compilare la scheda corrente con tutti Visto e NP
        </Typography>
      );
    },
  },
  {
    selector: `.${tour_13pile.step_01}`,
    content: () => {
      return (
        <Typography>
          Clicca qui per copiare i dati della scheda corrente su un altro
          elemento
        </Typography>
      );
    },
    /* style: {
      backgroundColor: '#bada55',
    }, */
  },
];
